import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { getImagesStaticUrl } from '../../helpers';
import { useUpgradeMembershipContext } from '../../utils/ContextProviders/UpgradeContext'


const PlanOptions = ({ perks, plan }) => (
  <ul className="plan-options">
    {perks.map(({
      label, check, boldText,
    }) => (
      <li key={label} className={cx({ 'strike-through': !check[plan] })}>
        <i
          className={
            cx(
              'far',
              { 'fa-times': !check[plan] },
              { 'times-icon': !check[plan] },
              { 'check-icon': check[plan] },
              { 'fa-check': check[plan] },
            )
          }
        />
        {label}
        {boldText !== '' && ' '}
        {boldText !== '' && (<b>{boldText}</b>)}
      </li>
    ))}
  </ul>
);



const DesktopCards = ({ getCouponContentKey }) => {
  const { growthUpgrade } = useUpgradeMembershipContext()
  const { variables } = growthUpgrade
  const perks = variables.perks?.list ?? []
  const seasonalPlans = variables.plans?.seasonal ?? {}
  const annualPlan = variables.plans?.annual ?? {}

  const seasonalPerksList = perks.filter((perk) => !perk.skip.seasonal);
  const annualPerksList = perks.filter((perk) => !perk.skip.annual);
  return (
    <div className="upgrade-plans-container mobile-hidden" data-testid="upgradePlansContainer">
      <div className='seasonal-plan-container'>
        <header className="plan-title plan-title__seasonal">
          {seasonalPlans.heading}
        </header>
        <span className="plan-subtitle-md">
          {seasonalPlans.subheading}
        </span>
        <span className="plan-subtitle current-plan" style={{ display: 'block' }}>
          {getCouponContentKey('seasonalPlan.note', 'Current Plan')}
        </span>
        <hr />
        <PlanOptions perks={seasonalPerksList} plan="seasonal" />
      </div>
      <div className='annual-plan-container'>
        <div style={{ position: 'relative' }}>
          <img
            className="best-value-desktop"
            /* eslint-disable-next-line max-len */
            //src="https://s3.amazonaws.com/dev-abtesting-assets/upgrade plancomp/images/best-value-desktop.svg"
            src={getImagesStaticUrl('best-value-desktop.svg')}
            alt="best value"
          />
          <header className="plan-title">
            {annualPlan.heading}
          </header>
        </div>
        <span className="plan-subtitle">
          {annualPlan.subheading}
        </span>
        <hr />
        <PlanOptions perks={annualPerksList} plan="annual" />
      </div>
    </div>
  );
};

DesktopCards.defaultProps = {
  showAdditionalPerks: false,
};

DesktopCards.propTypes = {
  showAdditionalPerks: PropTypes.bool,
};

export default DesktopCards;
